if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        // 24 Oct 2026 speed fix (same as BOB 22 Oct): start when the section is within ~600px of the viewport.
        // Before, requestIdleCallback (1.5s timeout) ran it during page load on every product page,
        // adding fetch + HTML parsing + card rendering to the main thread before the shopper scrolled.
        const start = () => {
          if (this.started) return;
          this.started = true;
          this.init();
        };
        if (window.FoxTheme && FoxTheme.Motion && typeof FoxTheme.Motion.inView === 'function') {
          FoxTheme.Motion.inView(this, start, { margin: '0px 0px 600px 0px' });
        } else if ('requestIdleCallback' in window) {
          requestIdleCallback(start, { timeout: 1500 });
        } else {
          start();
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
